import { render, staticRenderFns } from "./ShareCaseModal.vue?vue&type=template&id=4b8a4a14&"
import script from "./ShareCaseModal.vue?vue&type=script&lang=js&"
export * from "./ShareCaseModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareCaseModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports